"use client"
import { Intersection } from "../Intersection/Intersection"
import { HTMLAttributes, ReactNode, useState } from "react"
import css from "@css/Components.module.scss"
import cn from "classnames"

type Props = {
    className?: string
    children: ReactNode
    delay?: number
} & HTMLAttributes<HTMLDivElement>

export function SlideAppear({ className, children, delay = 0, ...divProps }: Props) {
    const [shown, setShown] = useState(false)
    return (
        <Intersection {...divProps} once className={cn(className, shown && css.active, css.appear, delay && css["delay" + delay])} onChange={setShown}>
            {children}
        </Intersection>
    )
}
